import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {
    MsalModule,
    MsalInterceptor,
    MsalRedirectComponent,
    MSAL_INSTANCE,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuard,
    MsalBroadcastService,
    MsalService
} from '@azure/msal-angular';

import { SharedModule } from '../../../shared/src/public_api';
import { SharedSettings } from '@shared/models/shared-settings';
import { ApiInterceptor } from '@shared/services/api.interceptor';
import { AuthService } from '@shared/authentication/auth.service';
import { MsalInstanceFactory, MsalInterceptorConfigFactory, MsalGuardConfigFactory } from '@shared/authentication/msal-factories';
import { LoggingService } from '@shared/services/logging.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';

import { environment } from '@environment';


// Prime NG
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect'
import { AccordionModule } from 'primeng/accordion';
import { AccountingReportsComponent } from './pages/accounting-reports/accounting-reports.component';
import { ManagementReportsComponent } from './pages/management-reports/management-reports.component';
import { ReportsViewComponent } from './components/reports-view/reports-view.component';
import { ReloadService } from '@shared/services/reload.service';
import {OtherReportsComponent} from "./pages/other-reports/other-reports.component";
import {EndOfShiftReportsComponent} from "./pages/end-of-shift-reports/end-of-shift-reports.component";
import {CustomerReportsComponent} from "./pages/customer-reports/customer-reports.component";
import { BrowserProviderService } from '@shared/services/browser-provider.service';
import { PsManagementReportsComponent } from './pages/ps-management-reports/ps-management-reports.component';
import { PsOperationsReportsComponent } from './pages/ps-operations-reports/ps-operations-reports.component';

@NgModule({
    declarations: [

        AppComponent,
        HomeComponent,
        AccountingReportsComponent,
        ManagementReportsComponent,
        CustomerReportsComponent,
        EndOfShiftReportsComponent,
        OtherReportsComponent,
        PsManagementReportsComponent,
        PsOperationsReportsComponent,
        ReportsViewComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MsalModule,
        AppRoutingModule,
        SharedModule.forRoot(environment),
        ButtonModule,
        CardModule,
        CalendarModule,
        CheckboxModule,
        InputTextModule,
        DropdownModule,
        MultiSelectModule,
        AccordionModule

    ],
    providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        }, {
            provide: MSAL_INSTANCE,
            useFactory: MsalInstanceFactory,
            deps: [ LoggingService, SharedSettings, BrowserProviderService ]
        }, {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MsalGuardConfigFactory,
            deps: [ SharedSettings ]
        }, {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MsalInterceptorConfigFactory,
            deps: [ SharedSettings ]
        },
        MsalGuard,
        MsalBroadcastService,
        MsalService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
    constructor(authService: AuthService, reloadService: ReloadService) {
        // check login early in site startup
        authService.isAuthenticated().subscribe(_ => {});
        reloadService.Start();
    }
}
